import { render } from "./ModuleSelectModal.vue?vue&type=template&id=3d0a3608&scoped=true"
import script from "./ModuleSelectModal.vue?vue&type=script&lang=js"
export * from "./ModuleSelectModal.vue?vue&type=script&lang=js"

import "./ModuleSelectModal.vue?vue&type=style&index=0&id=3d0a3608&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0a3608"]])

export default __exports__